import { useCallback, useEffect, useState, useMemo, useRef } from 'react';
import '../Analitos.scss';
import DataGrid, { Column, Button as Butt, Editing, RequiredRule, Form, Lookup, Toolbar, Item } from 'devextreme-react/data-grid';
import { useApiConfiguration } from '../../../api/api.configuration';
import Button from 'devextreme-react/button';
import { Tooltip } from 'devextreme-react';
import { UnitMeasurement } from '../../../images/icons';
import { UnitMeasurementBase } from './UnitMeasurementBase';
import { useAppSelector } from '../../../contexts/hooks';
import { Item as Items } from 'devextreme-react/form';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

export const UnitMeasurements = ({ dataUnidades, update }) => {
  const dataRef = useRef<DataGrid>(null);
  const { newUnitMeasurement, setUnitMeasurement, deleteUnitMeasurement, getUnitsBase } = useApiConfiguration();
  const [unitBase, setUnitBase] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const Sedes = useAppSelector((x) => x.configuration.Data?.ComboBox[0]);

  const updateData = () => {
    getUnitsBase().then((res) => {
      setUnitBase(res);
    });
  };

  useEffect(() => {
    getUnitsBase().then((res) => {
      setUnitBase(res);
    });
  }, []);

  const handleModalVisible = useCallback(() => {
    setIsModalVisible(true);
  }, []);

  const customData = useMemo(() => {
    return new CustomStore({
      key: 'Um_Id',
      load() {
        return Promise.resolve({
          data: dataUnidades,
        }).catch(() => {
          throw new Error('Error de carga de datos');
        });
      },
      insert: async (values) => {
        return newUnitMeasurement({ Unidad: values })
          .then((res) => {
            if (res === 105) {
              dataRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error insertando la unidad de medida');
          });
      },
      update: (key, values) => {
        return setUnitMeasurement({ Unidad: values, IdUnidad: key })
          .then((res) => {
            if (res === 107) {
              dataRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error actualizando la unidad de medida');
          });
      },
      remove: (key) => {
        return deleteUnitMeasurement({ IdUnidad: key })
          .then((res) => {
            if (res === 107) {
              dataRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error eliminando la unidad de medida');
          });
      },
    });
  }, [dataUnidades]);

  const customDataSrc = new DataSource({
    store: customData,
    reshapeOnPush: true,
  });

  const handleRefresh = useCallback(() => {
    update();
  }, [update]);

  return (
    <div>
      <DataGrid dataSource={customDataSrc} ref={dataRef}>
        <Editing mode='form' allowUpdating={true} allowAdding={true} allowDeleting={true} selectTextOnEditStart={true} texts={{ saveRowChanges: 'Guardar', cancelRowChanges: 'Cancelar', deleteRow: 'Eliminar', addRow: 'Agregar' }}>
          <Form>
            <Items dataField='Um_Nombre' />
            <Items dataField='Um_Sd_Id' />
            <Items dataField='Um_Umb_Id1' />
            <Items dataField='Um_FactorConversion1' />
            <Items dataField='Um_Umb_Id2' />
            <Items dataField='Um_FactorConversion2' />
          </Form>
        </Editing>
        <Toolbar>
          <Item location='before' locateInMenu='auto' showText='inMenu' widget='dxButton'>
            <Button id='UnidadMedidaBase' icon={UnitMeasurement} text='Unidad medida' stylingMode='text' visible={true} disabled={false} onClick={handleModalVisible} />
            <Tooltip target={'#UnidadMedidaBase'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
              Unidad medida base
            </Tooltip>
          </Item>
          <Item name='addRowButton' />
          <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
            <Button id='RefrecarResultun' icon='refresh' text='Refresh' stylingMode='text' onClick={handleRefresh} />
            <Tooltip target={'#RefrecarResultun'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
              Refrescar datos
            </Tooltip>
          </Item>
        </Toolbar>
        <Column allowGrouping={false} width={100} caption='UNIDAD' dataField='Um_Nombre' alignment='center' visible={true} allowEditing={true}>
          <RequiredRule />
        </Column>
        <Column allowGrouping={false} width={100} caption='SEDE' visible={true} allowEditing={true} dataField='Um_Sd_Id' alignment='center'>
          <Lookup dataSource={Sedes?.Data} valueExpr='Sd_Id' displayExpr='Sd_Nombre' />
          <RequiredRule />
        </Column>
        <Column allowGrouping={false} width={100} caption='UNIDAD BASE 1' visible={true} allowEditing={true} dataField='Um_Umb_Id1' alignment='center'>
          <Lookup dataSource={unitBase} valueExpr='Umb_Id' displayExpr='Umb_Nombre' />
          <RequiredRule />
        </Column>
        <Column allowGrouping={false} width={100} caption='FACTOR CONVERSION 1' visible={true} allowEditing={true} dataField='Um_FactorConversion1' alignment='center' />
        <Column allowGrouping={false} width={100} caption='UNIDAD BASE 2' visible={true} allowEditing={true} dataField='Um_Umb_Id2' alignment='center'>
          <Lookup dataSource={unitBase} valueExpr='Umb_Id' displayExpr='Umb_Nombre' />
        </Column>
        <Column allowGrouping={false} width={100} caption='FACTOR CONVERSION 2' visible={true} allowEditing={true} dataField='Um_FactorConversion2' alignment='center' />
        <Column type='buttons' caption={'ACCIÓN'} width={100}>
          <Butt name='edit' />
          <Butt name='delete' />
        </Column>
      </DataGrid>
      <UnitMeasurementBase visible={isModalVisible} setVisible={() => setIsModalVisible(false)} onUpdate={updateData} />
    </div>
  );
};
